import React, { useState, useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import Notiflix from "notiflix";
import {
  CheckCircleOutlined,
  LockOutlined,
  UnlockOutlined,
} from "@ant-design/icons";
//ANT DESIGN IMPORTS
import {
  Input,
  Row,
  Typography,
  Card,
  Form,
  Spin,
  Col,
  Divider,
  Button,
  Modal,
  List,
  Tag,
  DatePicker,
  Switch,
  InputNumber,
  Select,
  TimePicker,
  Alert,
} from "antd";

//PROJECT IMPORTS
import TopContent from "../../../components/layouts/TopContent";
import { BOM } from "../../../services/definedMethod";
import cnt from "../../../services/definedConstant";
import "../../../assets/styles/DatePicker.css";
import styles from "../../../assets/styles/styles";
import MainLayout from "../../../components/layouts/MainLayout";
import RecordStatus from "../../../components/RecordStatus";
import timezones from "../../../config/data/timezones.json";
import { apiConfig, labelConfig, staticConfig } from "../security.config";
import { showCheckerApprovalModal } from "../../../components/CheckerModal";
import dayjs from "dayjs";
import BuildPasswordErrorMessage from "../BuildPasswordErrorMessage";
import { encryptPayload } from "../../authentication/EncryptAuth";
const { Text, Title, Paragraph } = Typography;

const DetailedUser = (props) => {
  //DECLARED VARIABLES
  const { userData, rightBtn } = props;
  const { session } = userData;
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { state } = useLocation();
  const [useForm] = Form.useForm();
  const accessDays = Form.useWatch("accessDays", useForm);
  const accessTime = Form.useWatch("accessTime", useForm);
  const isTemporary = Form.useWatch("isTemporary", useForm);
  const [userDetail, setUserDetail] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [rolesList, setRolesList] = useState([]);
  const [timezonesData, setTimezonesData] = useState([]);
  const [objDetail, setObjDetail] = useState([]);

  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    getDetailById(state);
  }, []);

  const getDetailById = (params) => {
    setIsLoading(true);

    const url = `${apiConfig.Users}/${params.key}`;

    let body = {
      session,
    };

    /** FETCH ROLE */
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        const objDetail = res;
        setUserDetail(objDetail);
        let tempTimezones = [];

        switch (objDetail.enabled) {
          case false:
            dispatch({
              type: BOM.HasPermission("READ_USER") && cnt.RIGHT_APPROVE_BTN,
            });
            break;

          default:
            dispatch({
              type: BOM.HasPermission("READ_USER") && cnt.RIGHT_REJECT_BTN,
            });
            break;
        }

        {
          BOM.HasPermission("DELETE_USER") &&
            dispatch({ type: cnt.RIGHT_DELETE_BTN });
        }

        tempTimezones = timezones.map((tz) => ({
          label: tz.timezonename,
          value: tz.timezonename,
        }));

        setObjDetail(objDetail);
        setIsLoading(false);
        setRolesList(objDetail?.selectedRoles);
        setTimezonesData(tempTimezones);

        useForm.setFieldsValue({
          loginTimezone: objDetail?.timezone || null,
          loginTimeFrom: objDetail?.loginTimeFrom
            ? BOM.FormatArrayTime(objDetail?.loginTimeFrom)
            : null,
          loginTimeTo: objDetail?.loginTimeTo
            ? BOM.FormatArrayTime(objDetail?.loginTimeTo)
            : null,
          isTemporary: objDetail?.isTemporary ?? false,
          startDate: objDetail?.startDate
            ? dayjs(BOM.FormatArrayDate(objDetail?.startDate))
            : null,
          expiryDate: objDetail?.expiryDate
            ? dayjs(BOM.FormatArrayDate(objDetail?.expiryDate))
            : null,
        });

        // [cnt.RIGHT_APPROVE_BTN, cnt.RIGHT_REJECT_BTN].map((items) => {
        //   dispatch({ type: items });
        // });
      }
    });
  };

  const handleOnDelete = () => {
    let action = "Delete  ";
    let UserNo = `${state.firstname}`;

    Notiflix.Confirm.show(
      "Are you sure?",
      action + UserNo,
      "Yes",
      "No",

      function () {
        setIsLoading(true);
        const url = `${apiConfig.Users}/${state.key}`;
        let body = {
          method: "DELETE",
          session,
        };
        BOM.FetchReqAction(
          body,
          url,
          (err, res) => {
            if (err) {
              BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
              //STOP LOAD
              setIsLoading(false);
            } else {
              BOM.AlertMsg(cnt.SUCCESS, labelConfig.deleteUserMsg);
              navigate("/sms0100", {
                state: { state },
              });
              //STOP LOAD
              setIsLoading(false);
            }
          },
          {
            navigate,
            showCheckerModal: showCheckerApprovalModal,
            onCheckerApproval: (res) => {
              navigate("/sms0100");
              setIsLoading(false);
            },
          },
        );
      },

      function () {
        // No button
      },
    );
  };

  function handleOnEnable() {
    let action = "Enable ";
    let label = `${state.firstname} ${state.lastname}`;

    Notiflix.Confirm.show(
      "Are you sure?",
      action + label,
      "Yes",
      "No",

      function () {
        setIsLoading(true);
        const params = { command: "enable" };

        let body = {
          method: "PUT",
          session,
          params,
        };

        const url = `${apiConfig.Users}/${state.key}`;

        BOM.FetchReqAction(
          body,
          url,
          (err, res) => {
            if (err) {
              BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
              //STOP LOAD
              setIsLoading(false);
            } else {
              BOM.AlertMsg(cnt.SUCCESS, labelConfig.enableUserMsg);
              navigate("/sms0100");
              //STOP LOAD
              setIsLoading(false);
            }
          },
          {
            navigate,
            showCheckerModal: showCheckerApprovalModal,
            onCheckerApproval: (res) => {
              navigate("/sms0100");
              setIsLoading(false);
            },
          },
        );
      },

      function () {
        // No button
      },
    );
  }

  function handleOnDisable() {
    let action = "Disable ";
    let label = `${state.firstname} ${state.lastname}`;

    Notiflix.Confirm.show(
      "Are you sure?",
      action + label,
      "Yes",
      "No",

      function () {
        setIsLoading(true);
        const params = { command: "disable" };

        let body = {
          method: "PUT",
          session,
          params,
        };

        const url = `${apiConfig.Users}/${state.key}`;

        BOM.FetchReqAction(
          body,
          url,
          (err, res) => {
            if (err) {
              BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
              //STOP LOAD
              setIsLoading(false);
            } else {
              BOM.AlertMsg(cnt.SUCCESS, labelConfig.disableUserMsg);
              navigate("/sms0100");
              //STOP LOAD
              setIsLoading(false);
            }
          },
          {
            navigate,
            showCheckerModal: showCheckerApprovalModal,
            onCheckerApproval: (res) => {
              navigate("/sms0100");
              setIsLoading(false);
            },
          },
        );
      },

      function () {
        // No button
      },
    );
  }

  return (
    <MainLayout
      isEnableRightSidebar={true}
      onDelete={handleOnDelete}
      onApprove={() => handleOnEnable()}
      onReject={() => handleOnDisable()}
      approveTooltipTitle="Enable"
      rejectTooltipTitle="Disable"
    >
      {/* PART 1  IMPORT TOP CONTENT*/}
      <TopContent
        pageTitle={labelConfig.manageUsersDetail}
        pageItems={staticConfig.detailManageUsersItems}
      />

      <Spin spinning={isLoading} size="large">
        {/* PART 2 DISPLAY CONTENT */}
        <Form
          form={useForm}
          layout="vertical"
          style={{ paddingTop: 20, marginBottom: 50 }}
        >
          <Card
            style={{
              boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
              borderRadius: 20,
            }}
          >
            {BOM.HasPermission("UPDATE_USER") && (
              <ChangePassword
                isModalOpen={isModalOpen}
                setIsModalOpen={setIsModalOpen}
                session={session}
                state={state}
                getDetailById={getDetailById}
                userDetail={userDetail}
                refreshList={() => getDetailById(state)}
              />
            )}

            <Card
              style={{
                marginBottom: "2%",
                boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
              }}
            >
              <Row>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item label={<Text strong>{labelConfig.userName}</Text>}>
                    <Input
                      className="of-bold-disable-input"
                      disabled
                      value={userDetail?.username}
                    />
                  </Form.Item>
                </Col>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={<Text strong>{labelConfig.firstName}</Text>}
                  >
                    <Input
                      className="of-bold-disable-input"
                      disabled
                      value={userDetail.firstname}
                    />
                  </Form.Item>
                </Col>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item label={<Text strong>{labelConfig.lastName}</Text>}>
                    <Input
                      className="of-bold-disable-input"
                      disabled
                      value={userDetail?.lastname}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item label={<Text strong>{labelConfig.email}</Text>}>
                    <Input
                      className="of-bold-disable-input"
                      disabled
                      value={userDetail?.email}
                    />
                  </Form.Item>
                </Col>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item label={<Text strong>{labelConfig.branch}</Text>}>
                    <Input
                      className="of-bold-disable-input"
                      disabled
                      value={userDetail?.officeName}
                    />
                  </Form.Item>
                </Col>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item label={<Text strong>{labelConfig.staff}</Text>}>
                    <Input
                      className="of-bold-disable-input"
                      disabled
                      value={userDetail?.staff?.displayName || "N/A"}
                    />
                  </Form.Item>
                </Col>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item label={<Text strong>{labelConfig.status}</Text>}>
                    {userDetail?.enabled ? (
                      <Tag icon={<CheckCircleOutlined />} color={"success"}>
                        Enabled
                      </Tag>
                    ) : (
                      <Tag icon={<CheckCircleOutlined />} color={"red"}>
                        Disabled
                      </Tag>
                    )}
                  </Form.Item>
                </Col>
              </Row>{" "}
              <Row>
                <div
                  style={{
                    width: "100%",
                    padding: "16px",
                  }}
                >
                  {/* <Spin spinning={isLoading} tip="Loading..." size="large"> */}
                  <Divider orientation="left" orientationMargin="0">
                    <Title level={4} style={{ margin: 0, marginBottom: 0 }}>
                      {"Roles"}
                    </Title>
                  </Divider>

                  {rolesList?.length > 0 && (
                    <List
                      itemLayout="horizontal"
                      dataSource={rolesList}
                      renderItem={(item, index) => (
                        <Card style={{ width: "100%", marginBottom: 20 }}>
                          <List.Item>
                            <List.Item.Meta
                              title={item.name}
                              // description={item.description}
                              style={{ textTransform: "capitalize" }}
                            />
                          </List.Item>
                        </Card>
                      )}
                    />
                  )}
                  {/* </Spin> */}
                </div>
              </Row>
              <Row>
                <div
                  style={{
                    width: "100%",
                    padding: "16px",
                  }}
                >
                  <Divider orientation="left" orientationMargin="0">
                    <Title level={4} style={{ margin: 0, marginBottom: 0 }}>
                      {"User Access Control"}
                    </Title>
                  </Divider>

                  <Row>
                    <Col span={8} style={{ padding: "0px 8px" }}>
                      <Form.Item
                        name="loginTimeFrom"
                        label={
                          <Text strong>{labelConfig.manageUsersStartTime}</Text>
                        }
                      >
                        <TimePicker
                          disabled
                          style={{ width: "100%" }}
                          format="HH:mm"
                          showSecond={false}
                          defaultOpenValue={dayjs("00:00", "HH:mm")}
                          popupClassName="custom-timepicker-dropdown"
                        />
                      </Form.Item>
                    </Col>

                    <Col span={8} style={{ padding: "0px 8px" }}>
                      <Form.Item
                        name="loginTimeTo"
                        label={
                          <Text strong>{labelConfig.manageUsersEndTime}</Text>
                        }
                      >
                        <TimePicker
                          disabled
                          style={{ width: "100%" }}
                          format="HH:mm"
                          showSecond={false}
                          defaultOpenValue={dayjs("00:00", "HH:mm")}
                          popupClassName="custom-timepicker-dropdown"
                        />
                      </Form.Item>
                    </Col>

                    <Col span={8} style={{ padding: "0px 8px" }}>
                      <Form.Item
                        name="loginTimezone"
                        label={
                          <Text strong>{labelConfig.manageUsersTimezone}</Text>
                        }
                      >
                        <Select
                          className="read-only-select"
                          placeholder="Please select an option"
                          options={timezonesData}
                          showSearch
                          disabled
                        />
                      </Form.Item>
                    </Col>
                  </Row>

                  <Row>
                    <Col
                      span={8}
                      style={{
                        padding: "0px 8px",
                        marginBottom: 20,
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                      }}
                    >
                      <Form.Item
                        name="isTemporary"
                        valuePropName="checked"
                        style={{ marginBottom: 0 }}
                      >
                        <Switch
                          disabled
                          style={{
                            backgroundColor: isTemporary
                              ? "#92428B"
                              : "#F2F4F7",
                          }}
                        />
                      </Form.Item>
                      <Text style={{ marginLeft: 5, marginRight: 10 }}>
                        {labelConfig.manageUsersTemporaryUser}
                      </Text>
                    </Col>
                  </Row>

                  {isTemporary && (
                    <Row>
                      <Col span={8} style={{ padding: "0px 8px" }}>
                        <Form.Item
                          name="startDate"
                          label={
                            <Text strong>
                              {labelConfig.manageUsersStartDate}
                            </Text>
                          }
                        >
                          <DatePicker
                            className="of-bold-disable-input"
                            disabled
                            disabledDate={BOM.DisableBeforeCurrentDate}
                            placeholder={BOM.handlePlaceholderMsg(
                              `${labelConfig.fromDate}`,
                              "select",
                            )}
                            style={{
                              width: "100%",
                              height: 35,
                            }}
                          />
                        </Form.Item>
                      </Col>

                      <Col span={8} style={{ padding: "0px 8px" }}>
                        <Form.Item
                          name="expiryDate"
                          label={
                            <Text strong>{labelConfig.manageUsersEndDate}</Text>
                          }
                        >
                          <DatePicker
                            className="of-bold-disable-input"
                            disabled
                            disabledDate={BOM.DisableBeforeCurrentDate}
                            placeholder={BOM.handlePlaceholderMsg(
                              `${labelConfig.toDate}`,
                              "select",
                            )}
                            style={{
                              width: "100%",
                              height: 35,
                            }}
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                  )}
                </div>
              </Row>
            </Card>
          </Card>
        </Form>

        {/* PART 3 DISPLAY  RECORD STATUS */}
        <RecordStatus
          authStatus={""}
          makerID={""}
          makerDate={""}
          checkerID={""}
          checkerDate={""}
        />
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(DetailedUser);

const ChangePassword = (props) => {
  const {
    session,
    isModalOpen,
    setIsModalOpen,
    state,
    userDetail,
    refreshList,
  } = props;
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);

  const { Text } = Typography;
  const [form] = Form.useForm();

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleUnblockUser = () => {
    let action = "Unblock ";
    let label = userDetail?.username;

    Notiflix.Confirm.show(
      "Are you sure?",
      action + label,
      "Yes",
      "No",
      function () {
        const params = {
          command: "unlock",
        };
        const url = `${apiConfig.Users}/${userDetail.id}`;

        const body = {
          method: "POST",
          locale: "en",
          session,
          params,
        };

        setIsLoading(true);

        BOM.FetchReqAction(
          body,
          url,
          (err, res) => {
            if (err) {
              BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
              setIsLoading(false);
            } else {
              BOM.AlertMsg(cnt.SUCCESS, labelConfig.unblockUserMsg);

              // close modal
              setIsModalOpen(false);

              //refresh the list
              refreshList();

              //STOP LOAD
              setIsLoading(false);
            }
          },
          {
            navigate,
            showCheckerModal: showCheckerApprovalModal,
            onCheckerApproval: (res) => {
              // navigate("/sms0100");
              refreshList();
              setIsLoading(false);
            },
          },
        );
      },
      function () {
        // No button
      },
    );
  };

  const handlePasswordReset = () => {
    let action = "Reset  ";
    let label =
      "password for " + userDetail?.firstname + " " + userDetail?.lastname;

    Notiflix.Confirm.show("Are you sure?", action + label, "Yes", "No", () => {
      const url = `${apiConfig.Users}/${state?.key}`;
      const params = { command: "resetPassword" };
      const body = {
        method: "PUT",
        session,
        params,
      };

      setIsLoading(true);
      BOM.FetchReqAction(body, url, (err, res) => {
        if (err) {
          Modal.error({
            title: "Password Update Failed",
            content: BuildPasswordErrorMessage(err),
            width: 600,
            centered: false,
            style: { top: 400 },
            okButtonProps: {
              style: {
                backgroundColor: "var(--of-purple)",
              },
            },
          });
          setIsLoading(false);
        } else {
          BOM.AlertMsg(
            cnt.SUCCESS,
            "Password changed successfully. Please login again.",
          );

          setIsLoading(false);
        }
      });
    });
  };
  // const onSubmit = (formValues) => {
  //   const url = `${apiConfig.Users}/${state.key}`;
  //   const encryptedPassword = encryptPayload(formValues.password);
  //   const encryptedRepeatPassword = encryptPayload(formValues.repeatPassword);
  //   const body = {
  //     password: encryptedPassword,
  //     repeatPassword: encryptedRepeatPassword,
  //     method: "PUT",
  //     session,
  //   };

  //   setIsLoading(true);
  //   BOM.FetchReqAction(body, url, (err, res) => {
  //     if (err) {
  //       Modal.error({
  //         title: "Password Update Failed",
  //         content: BuildPasswordErrorMessage(err),
  //         width: 600,
  //         centered: false,
  //         style: { top: 400 },
  //         okButtonProps: {
  //           style: {
  //             backgroundColor: "var(--of-purple)",
  //           },
  //         },
  //       });
  //       setIsLoading(false);
  //     } else {
  //       BOM.AlertMsg(cnt.SUCCESS, labelConfig.changePasswordMsg);
  //       setIsModalOpen(false);
  //       setIsLoading(false);
  //     }
  //   });
  // };

  return (
    <>
      <Row>
        <Button
          type="primary"
          shape="round"
          className="of-primaryBtnColor"
          style={{ marginLeft: "auto" }}
          onClick={handlePasswordReset}
        >
          &nbsp;{labelConfig.changePassword}
        </Button>
        {!userDetail?.isAccountNonLocked && (
          <Button
            type="default"
            shape="round"
            icon={<UnlockOutlined />}
            style={{
              backgroundColor: "#6c757d",
              borderColor: "#6c757d",
              color: "white",
              marginLeft: "10px",
            }}
            onClick={handleUnblockUser}
          >
            &nbsp;{labelConfig.unblockUser}
          </Button>
        )}
      </Row>
      <Divider orientation="left" />
      <Modal
        title="Password Entry"
        open={isModalOpen}
        okText="Submit"
        cancelText="Cancel"
        okButtonProps={{
          autoFocus: true,
          htmlType: "submit",
          style: {
            ...styles.ofPrimaryBtnColor,
          },
        }}
        centered
        onCancel={handleCancel}
        width={800}
        modalRender={(dom) => (
          <Form layout="vertical" form={form} onFinish={handlePasswordReset}>
            {dom}
          </Form>
        )}
        style={{
          height: 600,
          overflow: "auto",
        }}
      >
        <Spin spinning={isLoading} tip="Loading..." size="large">
          <Row style={{ justifyContent: "space-betwen" }}>
            <Divider orientation="left" orientationMargin="0">
              {labelConfig.generalInfo}
            </Divider>
            <Col span={12} style={{ padding: "0px 8px" }}>
              <Form.Item
                style={{ width: "100%", marginBottom: "5px" }}
                name={"password"}
                rules={BOM.fieldRules("strong-password", true)}
              >
                <Input.Password
                  placeholder={`${labelConfig.password}`}
                  style={{ padding: 10, borderRadius: 10 }}
                  prefix={<LockOutlined className="site-form-item-icon" />}
                />
              </Form.Item>
            </Col>
            <Col span={12} style={{ padding: "0px 8px" }}>
              <Form.Item
                style={{ width: "100%", marginBottom: "5px" }}
                name={"repeatPassword"}
                rules={BOM.fieldRules("strong-password", true)}
              >
                <Input.Password
                  placeholder={`${labelConfig.repeatPassword}`}
                  style={{ padding: 10, borderRadius: 10 }}
                  prefix={<LockOutlined className="site-form-item-icon" />}
                />
              </Form.Item>
            </Col>
          </Row>
        </Spin>
      </Modal>
    </>
  );
};
